<template>
    <div class="infoengine risk-factor-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-6">
                    <h2 class="filter-heading">Risk Factor &amp; Weightage</h2>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'tablet-table-min-width',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <!-- <template slot="overRideTo" slot-scope="data">
                    <div v-if="data.item.overRideTo == ''">
                        N/A
                    </div>
                    <div v-else>
                        {{ data.value }}
                    </div>
                </template> -->
                <template slot="scoreScale" slot-scope="data">
                    <a href="javascript:void(0);" class="work-impact">
                        <span>View Score Scale</span>
                        <i class="icon-caret-right"></i>
                        <div class="custom-popover small">
                            <ul>
                                <li>
                                    <label>{{ highLabel(data.item) }} </label>
                                    <span class="bold">{{
                                        data.value.high
                                    }}</span>
                                </li>
                                <li>
                                    <label>{{ mediumLabel(data.item) }}</label>
                                    <span class="bold">{{
                                        data.value.medium
                                    }}</span>
                                </li>
                                <li>
                                    <label>{{ lowLabel(data.item) }}</label>
                                    <span class="bold">{{
                                        data.value.low
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                    </a>
                </template>
                <template slot="action" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('modify-risk-factor-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <!-- Get list records -->
        <base-records
            path="configurations/risk-factors"
            :query="query"
            :reset="reset"
            :show-pagination="false"
        ></base-records>
        <!-- Modify risk factor popup -->
        <modify-risk-factor-popup></modify-risk-factor-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modifyRiskFactorPopup from '@/components/popups/ModifyRiskFactorPopup.vue'
import resource from '@/api/resource'
const riskFactorsResource = new resource('configurations/risk-factors')
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        modifyRiskFactorPopup,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'factor',
                    label: 'Risk Factor',
                    class: 'w-320px',
                    sortable: true,
                },
                {
                    key: 'weight',
                    label: 'WEIGHT',
                    class: 'text-center',
                    sortable: true,
                },
                // {
                //     key: 'overRideTo',
                //     label: 'OVERRIDE TO',
                //     class: 'text-center text-capitalize',
                //     sortable: true,
                // },
                {
                    key: 'scoreScale',
                    label: 'Score Scale',
                    // sortable: true,
                },
                {
                    key: 'action',
                    label: 'ACTION',
                    class: 'single-list',
                },
            ],
            // Initilize query variables
            reset: new Date().getTime(),
            // Initilize data veriables
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'title',
                sortOrder: 'asc',
            },
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        highLabel(val) {
            return val.factor === 'Assets Under Management' ||
                val.factor === 'Suspicious Activity Reports'
                ? 'Sanction:'
                : 'High:'
        },
        mediumLabel(val) {
            return val.factor === 'Assets Under Management' ||
                val.factor === 'Suspicious Activity Reports'
                ? 'High'
                : 'Medium'
        },
        lowLabel(val) {
            return val.factor === 'Assets Under Management' ||
                val.factor === 'Suspicious Activity Reports'
                ? 'Medium:'
                : 'Low:'
        },
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        // Get all List of Risk Factor

        async getRecords() {
            this.query.dataSegmentId = this.dataSegmentId
            let { data } = await riskFactorsResource.list(this.query)

            this.items = data
        }, // End of getRecords() method
    }, // End of Component > methods
} // End of export default
</script>
